module.exports = __webpack_public_path__ + "img/Banner grande 1.22c30b55.png";